import {DataBaseComponent, DataBaseComponentState, Errors} from "./DataBaseComponent";

export default DataBaseComponent;

export {DataBaseComponent, DataBaseComponentState, Errors};